import { Button, Typography } from '@mui/material';

type ButtonProps = {
  onClick?: () => void;
  title: string;
  disabled: boolean;
};

const CustomButton = ({ title, disabled, ...rest }: ButtonProps) => (
  <Button
    type="submit"
    variant="rounded"
    fullWidth
    disabled={disabled}
    {...rest}
  >
    <Typography
      variant="body2"
      sx={{
        textTransform: 'none',
        color: 'inherit !important',
      }}
    >
      {title}
    </Typography>
  </Button>
);

export default CustomButton;
